var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.863 0.888916H16.1359C19.877 0.888916 21.989 3.01082 22 6.75192V17.0259C22 20.7659 19.877 22.8889 16.1359 22.8889H5.863C2.1219 22.8889 0 20.7659 0 17.0259V6.75192C0 3.01082 2.1219 0.888916 5.863 0.888916ZM11.0537 18.3349C11.5278 18.3349 11.9227 17.9829 11.9667 17.5099V6.30088C12.0107 5.95988 11.8468 5.61778 11.5498 5.43188C11.2407 5.24488 10.8667 5.24488 10.5708 5.43188C10.2727 5.61778 10.1088 5.95988 10.1407 6.30088V17.5099C10.1968 17.9829 10.5917 18.3349 11.0537 18.3349ZM16.1154 18.3349C16.5774 18.3349 16.9723 17.9829 17.0284 17.5099V13.9019C17.0603 13.5488 16.8964 13.2199 16.5983 13.0329C16.3024 12.8459 15.9284 12.8459 15.6204 13.0329C15.3223 13.2199 15.1584 13.5488 15.2024 13.9019V17.5099C15.2464 17.9829 15.6413 18.3349 16.1154 18.3349ZM6.8408 17.5099C6.7968 17.9829 6.4019 18.3349 5.9278 18.3349C5.4548 18.3349 5.0588 17.9829 5.0159 17.5099V9.90894C4.9829 9.56684 5.1468 9.22694 5.4449 9.03994C5.7408 8.85294 6.1159 8.85294 6.4129 9.03994C6.7088 9.22694 6.8749 9.56684 6.8408 9.90894V17.5099Z",
    fill: "#00A0DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledprogress);
export default __webpack_public_path__ + "static/media/filledprogress.b20b4e546c2cb761b1462eba8eefd2fb.svg";
export { ForwardRef as ReactComponent };